import { MarkupV2ListItem } from '../../../integrated-client/models';

interface ITableData {
  records: Array<MarkupV2ListItem>;
  totalItems?: number;
}

export class TableData implements ITableData {
  records: Array<MarkupV2ListItem>;
  totalItems?: number;

  constructor() {
    this.records = [];
  }
}

